import { LISTINGS_LINE } from 'utils/directory';
import { formatDate } from 'utils/newsroom';
import styles from 'styles/modules/BrokerDirectory.module.scss';

export default function DirectoryNotes({ updatedAt, order }) {
    return (
        <div className={styles.notes}>
            <p className={styles.listingsLine}>{LISTINGS_LINE}</p>
            {order && <p className={styles.updated}>{order}</p>}
            {updatedAt && (
                <p className={styles.updated}>
                    Updated{' '}
                    <time dateTime={updatedAt}>{formatDate(updatedAt)}</time>
                </p>
            )}
        </div>
    );
}
